// extracted by mini-css-extract-plugin
export default {"MediaRange":"MediaRange-module__MediaRange___1ahE4","inverse":"MediaRange-module__inverse___3RZ6p"};